$(document).ready(() => {
  $("#maintenanceTitle u").addClass("underline-warning no-text-decoration");
});
